import { Dialog, DialogContent, DialogContentText } from "@material-ui/core";
import { Link } from "react-router-dom";
import React from "react";
import {useSelector} from "react-redux";
import { shallowEqual } from "shallow-equal";

function NoSubscription() {
    const {
        expiredPlanError,
    } = useSelector(
        ({ auth }) => ({

            expiredPlanError: auth.expiredPlanError,
        }),
        shallowEqual
    );
  return (
    <Dialog
      open
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div
            style={{
              padding: 15,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <h2>Your plan has expired</h2>
                {expiredPlanError === 'Please choose a plan.' ?
                    <Link to="/plans">
                <span
                    style={{
                        fontSize: 16,
                    }}
                >
                  {expiredPlanError}
                </span>
                    </Link> :     <span
                        style={{
                            fontSize: 16,
                        }}
                    >
                  {expiredPlanError}
                </span>
                }

            </div>
          </div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}

export default NoSubscription;
